<template>
  <div class="tpp-page">
    <nearby-housekeeping-ops-nav active-path="/pages/tpp/nearby-housekeeping/product-changes" :platform-id="platformId" />
    <section class="tpp-panel">
      <div class="tpp-panel__head"><div><h2 class="tpp-panel__title">商品变化复核</h2><p class="tpp-muted">回调内容只用于核对。确认后请到商品管理修改并重新发布，系统不会自动上架。</p></div><el-button size="small" @click="load">刷新</el-button></div>
      <el-table :data="rows" v-loading="loading" border>
        <el-table-column prop="eventId" label="事件号" min-width="160" />
        <el-table-column prop="eventType" label="类型" width="160" />
        <el-table-column prop="externalProductId" label="三方商品" min-width="120" />
        <el-table-column prop="externalSkuId" label="三方规格" min-width="120" />
        <el-table-column prop="productId" label="本地商品" min-width="140" />
        <el-table-column prop="changedFields" label="变化字段" min-width="140" />
        <el-table-column prop="matchStatus" label="匹配" width="120" />
        <el-table-column prop="reviewStatus" label="复核" width="110" />
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <el-button type="text" @click="open(scope.row)">详情</el-button>
            <el-button v-if="scope.row.reviewStatus === 'OPEN'" type="text" @click="resolve(scope.row, 'CONFIRMED_CHANGED')">确认变化</el-button>
            <el-button v-if="scope.row.reviewStatus === 'OPEN'" type="text" @click="resolve(scope.row, 'IGNORED')">关闭</el-button>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <el-dialog title="变化详情" :visible.sync="visible" width="720px">
      <pre class="tpp-id">{{ detailText }}</pre>
    </el-dialog>
  </div>
</template>
<script>
import NearbyHousekeepingOpsNav from './nearbyHousekeepingNav.vue'
import { nearbyHousekeepingOpsMixin } from './nearbyHousekeepingOpsMixin'
import { getNearbyHousekeepingProductChange, listNearbyHousekeepingProductChanges, nhPayload, resolveNearbyHousekeepingProductChange } from '@/api/tpp/nearbyHousekeepingOpsApi'
import '../tpp.scss'
export default {
  name: 'NearbyHousekeepingProductChanges',
  components: { NearbyHousekeepingOpsNav },
  mixins: [nearbyHousekeepingOpsMixin],
  data() { return { loading: false, visible: false, rows: [], detailText: '' } },
  async created() { if (await this.ensureNearbyHousekeepingPlatform()) this.load() },
  methods: {
    async load() { this.loading = true; try { this.rows = (await listNearbyHousekeepingProductChanges({ platformId: this.platformId, page: 1, row: 100 })).data || [] } catch (e) { this.$message.error(e.message || '复核列表加载失败') } finally { this.loading = false } },
    async open(row) { try { const detail = nhPayload(await getNearbyHousekeepingProductChange({ platformId: this.platformId, reviewId: row.reviewId })); this.detailText = JSON.stringify(detail, null, 2); this.visible = true } catch (e) { this.$message.error(e.message || '详情加载失败') } },
    async resolve(row, resolution) { try { const note = await this.$prompt('填写核对说明', '处理复核'); await resolveNearbyHousekeepingProductChange({ platformId: this.platformId, reviewId: row.reviewId, resolution, note: note.value }); this.$message.success('复核已处理'); this.load() } catch (e) { if (e !== 'cancel') this.$message.error(e.message || '处理失败') } }
  }
}
</script>
